import {cssTheme} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import {renderWidget} from '..'
import type {CostDetailWidgetProps} from '../types'
import {box, dots} from './classes'
import type {CostDetailProps} from './types'

export const CostDetailWidgetUI: React.FC<CostDetailProps> = props => {
  const {lead_text, trail_text, dot_style, color} = props

  return (
    <div className={box}>
      {lead_text?.items.map(item => renderWidget(item))}
      <div className={dots} style={{fontSize: dot_style.font_size, borderColor: color}} />
      {trail_text?.items.map(item => renderWidget(item))}
    </div>
  )
}

export const CostDetailWidget = memo<CostDetailWidgetProps>(({config: props}) => {
  const color = cssTheme.default.day[props.dot_style.color || 'textMinor']?.hex || cssTheme.default.day.textMinor.hex

  return <CostDetailWidgetUI {...props} color={color} />
})

CostDetailWidget.displayName = 'CostDetail'
